import { Module } from 'vuex';

import state, { AuthInterface } from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { StateInterface } from '@/interfaces/projects';


const authModule: Module<AuthInterface, StateInterface> = {
    namespaced: true,
    actions,
    getters,
    mutations,
    state
}


export default authModule;